<img [src]="_imageUrl" class="logo-img" (click)="fileInput.click()">

<input hidden #fileUploadCtrl (change)="onSelectImage($event)" 
(click)="resetImage($event)"
#fileInput type="file"
    accept="image/png,image/jpeg"
    [disabled]="isDisabled"
    >